module.exports = __webpack_public_path__ + "static/img/energy-h5-7.14b0de4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/energy-h5-7.png
// module id = 6p+L
// module chunks = 34